import * as React from 'react'

import { AlertDialogSlide } from '@sales-center/components'

import { EDIT_COVERAGE_TITLE } from '../constants'
import { getEditCoverageMessage } from '../utils/coverageError'

type Props = {
  labels: string[] | null
  onClose: () => void
}

export function EditCoverageBlockDialog(props: Props) {
  const { labels, onClose } = props

  return (
    <AlertDialogSlide
      title={EDIT_COVERAGE_TITLE}
      message={labels ? getEditCoverageMessage(labels) : ''}
      open={!!labels}
      disableDelete
      cancelButtonText="Close"
      cancelClick={onClose}
    />
  )
}

EditCoverageBlockDialog.displayName = 'EditCoverageBlockDialog'
